import Icon from '@components/icon/Icon';
import { mdiFileDocumentEdit } from '@mdi/js';
import { Button } from '@trussworks/react-uswds';

import '@pages/PublicNotices/public-notices-table/actionsTableCell.scss';
import { connect } from 'redux-bundler-react';
import { isUserProfileAgent } from '@src/app-pages/Forms/components/modals/_shared/UserProfileAgent';
import { useModal } from '@stores';
import { useUserProfile } from '@hooks';

const AgentsActionsTableCell = connect(
  ({ modalComponent, row, isReadOnly, rowData, setRowData, contactType = 'Contact' }) => {
    const { openModal } = useModal();
    const { userProfileData } = useUserProfile();
    const id = row?.original?.contactID ? row.original.contactID : rowData.indexOf(row.original);

    const modalProps = {
      data: row.original,
      edit: true,
      id,
      isReadOnly,
      rowData,
      rowIndex: row.index,
      setRowData,
    };

    const handleButtonClick = () => openModal(modalComponent, modalProps);

    return (
      <div
        className='button-container'
        hidden={isUserProfileAgent(
          row.original,
          userProfileData?.firstName,
          userProfileData?.lastName,
          userProfileData?.emailAddress
        )}
      >
        <Button
          className='edit-agent'
          title={`Edit ${contactType}`}
          onClick={() => handleButtonClick()}
          disabled={isReadOnly}
        >
          <Icon aria-label={`Edit ${contactType}`} focusable={false} path={mdiFileDocumentEdit} size={'24px'} />
        </Button>
      </div>
    );
  }
);

export default AgentsActionsTableCell;
